<template>
  <div id="contenedor-agregar-nuevo-fallo">
    <v-form v-model="formularioValido" ref="agregarNuevoFallo">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Fallo del Participante
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Participante"
            v-model="nombreParticipante"
            readonly
          >
          </custom-text-field>
          <v-row>
            <v-col cols="12" md="3">
              <v-switch
                label="¿Asistió?"
                v-model="licitacionFallo.asistio"
                inset
              >
              </v-switch>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch
                v-model="licitacionFallo.ganador"
                :disabled="existeGanador"
                inset
              >
              <template v-slot:label>
                <span v-if="existeGanador">Ya existe un Ganador</span>
                <span v-else>¿Ganador?</span>
              </template>
              </v-switch>
            </v-col>
          </v-row>
          <custom-text-area
            cols="12"
            md="12"
            v-model="licitacionFallo.observaciones"
            label="Observaciones"
            auto-grow
            required
          >
          </custom-text-area>
          <v-row>
            <v-col cols="12" md="4">
              <v-row>
                <custom-text-field-green
                  v-model="licitacionFallo.monto"
                  class="mx-0 px-0"
                  cols="12"
                  label=" Monto"
                  prefix="$"
                  type="number"
                >
                </custom-text-field-green>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixLicitacionesFallo from './mixLicitacionesFallo';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';

export default {
  name: 'LicitacionAgregarAperturaPropuesta',
  mixins: [mixLicitacionesFallo],
  props: {
    participanteLicitacion: {
      type: Object,
      required: true,
    },
    existeGanador: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomTextArea,
    CustomButton,
    CustomTextFieldGreen,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      nombreParticipante: this.participanteLicitacion.contratista.nombreRazonSocial,
      licitacionFallo: {
        idLicitacion: this.participanteLicitacion.idLicitacion,
        idParticipante: this.participanteLicitacion.id,
        asistio: false,
        ganador: false,
        observaciones: '',
        monto: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.agregarNuevoFallo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    guardar() {
      const monto = parseFloat(this.licitacionFallo.monto);
      this.licitacionFallo.monto = monto;
      this.mixAgregarLicitacionFallo();
    },
  },
};
</script>

<style>
</style>
